export default __webpack_public_path__ + "images/84f58446a0adaafa149f944c23aaa367.png";